module.exports = __webpack_public_path__ + "static/media/edit.1a911345.svg";